/**
 * YOS-10255: returns the secondary seller (the seller key holder) only when it adds information to
 * the primary one.
 *
 * A seller key session hangs off the terminal session it was validated from, and the reporting views
 * name that parent as the primary seller. When the parent is a manual login session it has no name of
 * its own — `sp_insert_login_session` never writes `session_name` — so `primary_session_name` falls
 * back to the key session's own name, which is the person's, and primary and secondary come back
 * identical. Rendering both then reads as corrupted data ("Ana Dos · Ana Dos") when the truth is only
 * that the terminal has no name to show, so the second one is dropped and the row reads exactly as it
 * did before YOS-10255.
 *
 * @param primary Name resolved as the primary seller.
 * @param secondary Name of the seller key holder, as the API sends it.
 * @returns The secondary name, or `undefined` when there is none or it repeats the primary.
 */
export const getDistinctSecondarySeller = (
  primary?: string | null,
  secondary?: string | null,
): string | undefined => {
  const primaryName: string = (primary || "").trim();
  const secondaryName: string = (secondary || "").trim();

  if (!secondaryName) {
    return undefined;
  }

  return secondaryName.toLowerCase() === primaryName.toLowerCase()
    ? undefined
    : secondaryName;
};
